import { UIHeading5, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';
import { IBuilderStats } from '../../types/newbuilding/builder';

export interface IDeveloperLayoutProps {
  logo: React.ReactElement<any>;
  stats?: IBuilderStats;
  yearOfFoundation?: number;
}

export const BuilderLayout: React.FC<IDeveloperLayoutProps> = ({ logo, stats, yearOfFoundation }) => {
  return (
    <div className={style['container']} data-testid="BuilderLayout">
      <div>{logo}</div>

      <div className={style['wrapper']}>
        {yearOfFoundation && (
          <div className={style['title']}>
            <UIText3 color="text-secondary-default">Год основания</UIText3>
            <UIHeading5 color="text-primary-default">{yearOfFoundation}</UIHeading5>
          </div>
        )}

        {stats?.done?.housesText && (
          <a className={style['title']} href={stats.done?.qs} target="blank" rel="noreferrer">
            <UIText3 color="text-secondary-default">Сдано</UIText3>
            <UIHeading5 color="text-primary-default">
              {stats.done.housesCount} {stats.done.housesText} {stats.done.newbuildingText}
            </UIHeading5>
          </a>
        )}

        {stats?.inProgress?.housesText && (
          <a className={style['title']} href={stats.inProgress?.qs} target="blank" rel="noreferrer">
            <UIText3 color="text-secondary-default">Строится</UIText3>
            <UIHeading5 color="text-primary-default">
              {stats.inProgress.housesCount} {stats.inProgress.housesText} {stats.inProgress.newbuildingText}
            </UIHeading5>
          </a>
        )}
      </div>
    </div>
  );
};
